import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import { Checkbox } from '../../checkbox/Checkbox'
import { FormField } from '../FormField'

export type CheckboxFieldProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  labelPosition?: 'left' | 'right'
  labelSize?: 'medium' | 'small'
  labelStyle?: Style
  inputStyle?: Style
  disabled?: boolean
  tooltipText?: string
}

export const CheckboxField = <T extends FieldValues = FieldValues>({
  name,
  ...checkboxProps
}: CheckboxFieldProps<T>) => {
  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, errorMessage }) => (
        <Checkbox
          {...checkboxProps}
          selected={!!value}
          onClick={() => onChange(!value)}
          errorMessage={errorMessage}
        />
      )}
    />
  )
}
